import { Button, message } from "antd";
import { RollbackOutlined } from "@ant-design/icons";

export const RestoreSession = () => {
  const originalUserId = localStorage.getItem("originalUserId");
  const impersonatedUserId = localStorage.getItem("impersonatedUserId");

  console.log("RestoreSession component:", {
    originalUserId,
    impersonatedUserId,
  });

  if (!originalUserId || !impersonatedUserId) {
    console.log(
      "No impersonation data found, not rendering RestoreSession button"
    );
    return null;
  }

  const handleRestore = async () => {
    try {
      console.log("Restoring original session");
      console.log("Original values:", {
        originalUserId: localStorage.getItem("originalUserId"),
        impersonatedUserId: localStorage.getItem("impersonatedUserId"),
      });

      // Remove the impersonated user ID
      localStorage.removeItem("impersonatedUserId");

      // Clear the stored original user ID
      localStorage.removeItem("originalUserId");

      console.log("After clearing:", {
        originalUserId: localStorage.getItem("originalUserId"),
        impersonatedUserId: localStorage.getItem("impersonatedUserId"),
      });

      message.success("Successfully restored original session");
      console.log("Impersonation data cleared, reloading page");

      // Force a page reload to apply the restoration
      setTimeout(() => {
        console.log("Executing redirect now");
        window.location.href = "/dashboard";
      }, 500);
    } catch (error) {
      console.error("Error restoring session:", error);
      message.error(
        error instanceof Error ? error.message : "Failed to restore session"
      );
    }
  };

  return (
    <Button
      icon={<RollbackOutlined />}
      onClick={handleRestore}
      style={{
        backgroundColor: "#ff4d4f",
        borderColor: "#ff4d4f",
        color: "white",
      }}
    >
      End Impersonation
    </Button>
  );
};
